<template>
  <v-card class="scrollable-div" elevation="3">
    <v-card-title class="headline">
      <v-typography variant="h5" class="modal-title">Update Student</v-typography>
      <v-btn icon @click="emit('close')" class="square-btn">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-if="student" :key="formKey" @submit.prevent="updateStudent">
        <v-text-field v-model="student.name" label="Name" :counter="10" required></v-text-field>
        <v-text-field v-model="student.roll_symbol_no" label="Roll no" required></v-text-field>
        <v-text-field v-model="student.birth_date" label="Date of Birth" type="text" required></v-text-field>
        <v-text-field v-model="student.parent_name" label="Parent Name" required></v-text-field>
        <v-text-field v-model="student.address" label="Address" required></v-text-field>
        <!-- <v-select v-model="student.gender" :items="['Male', 'Female', 'Others']" label="Gender" required></v-select> -->

        <!-- <v-text-field v-model="student.designation" label="Designation" :counter="10" required></v-text-field> -->

        <v-text-field v-model="student.contact" label="Contact" :counter="15" required></v-text-field>

        <v-file-input v-model="student.image" accept="image/*" label="Upload Image"
          @update:model-value="handleImageChange"></v-file-input>

        <v-row class="justify-end m-2">
          <v-btn class="me-2" @click="updateStudent">Submit</v-btn>
          <v-btn @click="clear">Clear</v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";
import axios from "axios";
import { apiConfig } from "@/config/apiConfig";
import { useTheme } from '@/composables/useThemes'
const { isDarkTheme } = useTheme()
import Swal from "sweetalert2";
const props = defineProps({
  studentData: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["updateStudent", "close"]);

const student = ref({ ...props.studentData });
const formKey = ref(0);
const successMessage = ref("");
const error = ref(null);

// Watch for prop changes and update local state
watch(
  () => props.studentData,
  (newStudent) => {
    student.value = { ...newStudent };
  },
  { deep: true }
);

const mapToSmallValue = (key, value) => {
  const mapping = {
    gender: {
      Male: "male",
      Female: "female",
      Others: "others",
    },
  };
  // console.log("maping ", mapping[key]?.[value]);
  // console.log("not maping ", mapping[key]?.[value] || value);
  return mapping[key]?.[value] || value; 
};

// Handle Image Change
// const handleImageChange = (file) => {
//   if (file) {
//     student.value.image = file;
//   }
// };

const handleImageChange = (file) => {
  if (file && file instanceof File) {
    student.value.image = file;
  } else {
    student.value.image = null;
  }
};

const updateStudent = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const updatedData = { ...student.value };
  try {
    const formData = new FormData();
    Object.keys(updatedData).forEach((key) => {
      if (updatedData[key]) {
        const mappedValue = mapToSmallValue(key, updatedData[key]);
        formData.append(key, mappedValue);
      }
    });
    if (student.value.image && student.value.image instanceof File) {
      formData.append("image", student.value.image);
    } else {
      formData.delete("image");
      console.warn("No valid image selected.");
    }
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.studentsDetail}`,
      formData,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
          "STUDENT-ID": updatedData.id,
        },
      }
    );
    emit("updateStudent", response.data);
    successMessage.value = "Student updated successfully!";
    Swal.fire({
      icon: "success",
      title: successMessage.value,      
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: isDarkTheme.value ? '#333' : '#fff',
      color: isDarkTheme.value ? '#fff' : '#000',
      iconColor: isDarkTheme.value ? "#0f0" : "#28a745",
    });
  } catch (err) {
    error.value = `Error updating student: ${err.response ? err.response.data : err.message
      }`;
  }
};

const clear = () => {
  student.value = { ...props.studentData };
  formKey.value++; // Reset form to clear inputs
};
</script>
